import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M14.536.964c.276.001.5.224.501.501V5a.503.503 0 0 1-.501.501.502.502 0 0 1-.501-.501l.001-2.329-4.218 4.218a.5.5 0 0 1-.707-.707l4.218-4.218L11 1.965a.503.503 0 0 1-.501-.501.502.502 0 0 1 .501-.5h3.536zM6.889 9.111a.5.5 0 0 1 0 .707l-4.218 4.218L5 14.035c.276.001.5.224.501.501a.502.502 0 0 1-.501.5H1.464a.503.503 0 0 1-.501-.501V11a.501.501 0 1 1 1.002 0l-.001 2.329 4.218-4.218a.5.5 0 0 1 .707 0z" />
		</svg>
	);
};
